import Vue from 'vue';

Vue.directive('fallback-src', {
  bind(el, binding) {
    el.addEventListener('error', () => {
      // eslint-disable-next-line no-param-reassign
      el.src = binding.value;
    });
  },
});
